import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-up-left"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerUpLeft"><path fillRule="evenodd" clipRule="evenodd" d="M20.2071 20.2071V9.70711H4.91422L8.91421 13.7071L8.20711 14.4142L3 9.20711L8.20711 4L8.91421 4.70711L4.91422 8.70711H21.2071V20.2071H20.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerUpLeft;
